import { render } from "./appPicture-image.vue?vue&type=template&id=abff08e2&scoped=true"
import script from "./appPicture-image.vue?vue&type=script&lang=js"
export * from "./appPicture-image.vue?vue&type=script&lang=js"

import "./appPicture-image.vue?vue&type=style&index=0&id=abff08e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abff08e2"]])

export default __exports__